<app-loading *ngIf="isLoad"></app-loading>

<app-header *ngIf="hfShow" ></app-header>
<router-outlet></router-outlet>
<section *ngIf="hfShow" class="productOffer">
    <app-section></app-section>
</section>
<app-footer *ngIf="hfShow"></app-footer>